
import requests from "./api/api";

const DriverService = {

    getMyCargo:(body)=>requests.post('/file/v1/upload',body),
    updateDriverInfo:(body)=>requests.put('/user/v1/register-driver-by-user',body),
    getAllFavorites:(body)=>requests.get('/user/v1/get-favorite-cargos-list-by-driver',body),
    getAllMyCargo:(body)=>requests.get('/cargo/v1/get-cargo-accepted-by-driver',body),
    acceptCargo:(body)=>requests.patch('/cargo/v1/accepted-by-user',body),
    removerCargo:(body)=>requests.patch('/cargo/v1/cancel-request-by-user',body),


  
   


};

export default DriverService;